var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsisVSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.3,97.1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,97.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,96.9h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8,97.1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,97h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,90.5l-2.8-1.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,90.2h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,81.9a8.2,8.2,0,0,0,4.1-1.2A8.2,8.2,0,0,1,75,81.9Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3,90.3h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,90.3l-.3-.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,96.9,70,96.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,97h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7,52.1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,52.1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2,52.1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,52.2h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,52.4h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2,61.3a21.6,21.6,0,0,1,2.9,5.4A21.6,21.6,0,0,0,93.2,61.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,90.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,90.2h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,59.1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,52.2h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,59h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2,59.1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1,88.9l1.2-1h0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,96.5a1.1,1.1,0,0,0,.5-.8A1.1,1.1,0,0,1,80.3,96.5Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,80.1c.2,0,.2.1.3.2s-.1-.2-.3-.2l-3.8-2.3c.1-.5.1-1,.2-1.6s-.1,1.1-.2,1.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,95.6V91.1l-1.5-.6,1.5.6v4.5a1.2,1.2,0,0,0,.5.9A1.2,1.2,0,0,1,69.2,95.6Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,90.3l.3-.2,3.9-2.2-3.9,2.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,52.8l-.3-.2-1.3-.2,1.3.2Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,73c-.1-.5-.1-1-.2-1.6l1.9-1.1-1.9,1.1C92.3,72,92.3,72.5,92.4,73Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6,68.3a.8.8,0,0,0-.1-.4,5.6,5.6,0,0,0-.4-1.2,5.6,5.6,0,0,1,.4,1.2A.8.8,0,0,1,96.6,68.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.2 59.1 86.3 61.4 86.3 61.4 90.2 59.1",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3,59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,76.7l1.7-1V73.5L52,72.6a5,5,0,0,1-2.2-5.8,25.7,25.7,0,0,1,5.8-10.1,5.1,5.1,0,0,1,3.7-1.6,4.2,4.2,0,0,1,2.4.7l1.7.9,1.9-1.1V53.2l-6.8-1.7a27.9,27.9,0,0,1-32.8,0L15.3,54.2A14,14,0,0,0,4.6,67.8v5.5a7,7,0,0,0,7,7h38A5,5,0,0,1,52,76.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,59.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,67.4h0a7.3,7.3,0,0,1,4.1,1.2A7.3,7.3,0,0,0,75,67.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,59.3h0a15.6,15.6,0,0,0-1.6,2,15.6,15.6,0,0,1,1.6-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.1,
    cy: 28.7,
    r: 23.5,
    transform: "translate(-0.5 56.6) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7,67.8v1.3a7.1,7.1,0,0,1,2.6,5.5,7.5,7.5,0,0,1-3.2,6.1A8.2,8.2,0,0,1,75,81.9H73.5l-1.3-.5a5.9,5.9,0,0,1-1.7-1H53.7a1.2,1.2,0,0,0-.2,1,21.3,21.3,0,0,0,1.4,3.5A15.9,15.9,0,0,0,56.2,87a15.4,15.4,0,0,0,2.3,2.9l.3.3h.7l.3-.2,3.9-2.2,1.2,1,2.8,1.6,1.5.6v4.5a1.2,1.2,0,0,0,.5.9H70l1.3.3h7.5l1.2-.3h.3a1.1,1.1,0,0,0,.5-.8h0V91.1l1.5-.6,2.8-1.6,1.2-1h0l3.9,2.2.3.2h.7l.4-.3a22.2,22.2,0,0,0,4.9-8.6.9.9,0,0,0,0-.7l-.2-.3c-.1-.1-.1-.2-.3-.2l-3.8-2.3c.1-.5.1-1,.2-1.6a17.1,17.1,0,0,0,0-3.2c-.1-.5-.1-1-.2-1.6l1.9-1.1L96,69.2a.8.8,0,0,0,.5-.5.8.8,0,0,0,0-.8,5.6,5.6,0,0,0-.4-1.2,21.6,21.6,0,0,0-2.9-5.4l-1.6-2-.4-.2h-1l-3.9,2.3h0a17.4,17.4,0,0,0-2.6-1.9l-1.4-.7-1.5-.6V53.7a1.9,1.9,0,0,0-.2-.7l-.3-.2-.3-.2-1.3-.2H71.3l-1.3.2a1.2,1.2,0,0,0-.8,1.1v.5A14.1,14.1,0,0,1,79.7,67.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7,61.4l-3.9-2.3h-1l-.3.2h0a15.6,15.6,0,0,0-1.6,2,14.3,14.3,0,0,0-1.4,2,24,24,0,0,0-1.1,2.3,9.2,9.2,0,0,0-.9,2.3,1,1,0,0,0,.5,1.3l3.9,2.2a17.2,17.2,0,0,0,0,6.4L54,80.1l-.3.2H70.5l-.6-.5a6.2,6.2,0,0,1-1.8-3,6,6,0,0,1,0-4.3,5.8,5.8,0,0,1,1.8-3,6.3,6.3,0,0,1,2.3-1.6l1.3-.4H75a7.3,7.3,0,0,1,4.1,1.2l.6.5V67.8A14.1,14.1,0,0,0,69.2,54.2v4A16.9,16.9,0,0,0,63.7,61.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,89.9l-.4.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6,90.3h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2,59.1l.4.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3,61.4a17.4,17.4,0,0,0-2.6-1.9,17.4,17.4,0,0,1,2.6,1.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,90.2h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8,59h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,81.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,69.2l-1.9,1.1L96,69.2a.8.8,0,0,0,.5-.5A.8.8,0,0,1,96,69.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,52.1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,52.3h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,52.1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,52.2h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,58.2l1.5.6-1.5-.6V53.7a1.9,1.9,0,0,0-.2-.7,1.9,1.9,0,0,1,.2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,52.6l1.3-.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,52.2h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5,81.8l-1.3-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5,59h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3,52.3h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,97.2h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,96.9h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,90.3h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,87a15.4,15.4,0,0,0,2.3,2.9l.3.3-.3-.3A15.4,15.4,0,0,1,56.2,87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,97.1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,96.6l-1.2.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,95.6h0V91.1l1.5-.6-1.5.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9,84.8a21.3,21.3,0,0,1-1.4-3.5A21.3,21.3,0,0,0,54.9,84.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,87a15.9,15.9,0,0,1-1.3-2.2A15.9,15.9,0,0,0,56.2,87Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,90.3h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5,81.3a.9.9,0,0,0,0-.7A.9.9,0,0,1,96.5,81.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,97.1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4,96.9h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,97.2h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.3 87.9 90.2 90.1 86.3 87.9 86.3 87.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,59.1h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,72.5a6,6,0,0,0,0,4.3,6,6,0,0,1,0-4.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4,59h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5,59.3l.3-.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5,63.3a14.3,14.3,0,0,1,1.4-2A14.3,14.3,0,0,0,55.5,63.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.7 61.4 59.8 59.1 59.8 59.1 59.8 59.1 63.7 61.4",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,67.4h0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4,65.6a24,24,0,0,1,1.1-2.3A24,24,0,0,0,54.4,65.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,72.5a5.8,5.8,0,0,1,1.8-3A5.8,5.8,0,0,0,68.1,72.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,67.9l1.3-.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,71.4a17.2,17.2,0,0,0,0,6.4A17.2,17.2,0,0,1,57.9,71.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,79.8a6.2,6.2,0,0,1-1.8-3A6.2,6.2,0,0,0,69.9,79.8Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVSolid);
export default __webpack_public_path__ + "static/media/ellipsis-v-solid.d3ea72fa.svg";
export { ForwardRef as ReactComponent };